import React from 'react';
import { useViewEvent } from '@stitch-fix/event-reporter';
import CategoryCardBase, { CategoryCardBaseProps } from './CategoryCardBase';

export type CategoryCardProps = CategoryCardBaseProps & {
  /**
   * The category ID
   */
  categoryId: string;
};

/**
 * A CategoryCard displays basic information about any given category, a pattern seen often in Shop & on Home feed. The component displays details about the category and displays the card with different variant styles.
 *
 * Exposed via a nested import: `import CategoryCard from '@stitch-fix/mode-react/CategoryCard';`
 *
 * This component is pre-instrumented with Product Tracking Events (PTEs).
 *
 * **WIP: This component is currently being developed for Go-to-Market and may be converted to a general `Card` component. Please refrain from using this until active development has completed and this not has been removed.**
 */
const CategoryCard = ({
  categoryId,
  onClick,
  ...containerProps
}: CategoryCardProps) => {
  const { ref, EventProvider, reportSelectEvent } = useViewEvent({
    schema: 'category_view',
    name: 'category_card',
    category_id: categoryId,
  });

  const handleClick = () => {
    reportSelectEvent({
      schema: 'category_select',
      name: 'category_card',
      category_id: categoryId,
      action_name: 'navigate_to_category',
    });

    onClick?.();
  };

  return (
    <EventProvider>
      <CategoryCardBase ref={ref} onClick={handleClick} {...containerProps} />
    </EventProvider>
  );
};

export default CategoryCard;
